
import { UseFormReturn } from "react-hook-form";
import { ProcurementFormValues } from "../schema";
import { CostInputFields } from "./cost-breakdown/CostInputFields";
import { OtherCostDescription } from "./cost-breakdown/OtherCostDescription";
import { VatToggle } from "./cost-breakdown/VatToggle";
import { CostSummary } from "./cost-breakdown/CostSummary";
import { useCostCalculations } from "./cost-breakdown/useCostCalculations";

interface CostBreakdownFieldsProps {
  form: UseFormReturn<ProcurementFormValues>;
  onSubtotalChange?: (subtotal: number) => void;
}

export const CostBreakdownFields = ({ form, onSubtotalChange }: CostBreakdownFieldsProps) => {
  const {
    totalQuantity,
    totalItemAmount,
    totalUnitCost,
    totalAdditionalCosts,
    grandTotal,
    vatApplicable,
    otherCost,
    itemsCount
  } = useCostCalculations({ form, onSubtotalChange });

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium">Cost Breakdown (per unit)</h3>
      
      <CostInputFields form={form} />
      
      <OtherCostDescription form={form} otherCost={otherCost} />
      
      <VatToggle form={form} />
      
      <CostSummary
        totalItemAmount={totalItemAmount}
        totalQuantity={totalQuantity}
        totalUnitCost={totalUnitCost}
        totalAdditionalCosts={totalAdditionalCosts}
        grandTotal={grandTotal}
        vatApplicable={vatApplicable}
        itemsCount={itemsCount}
      />
    </div>
  );
};
